import { Button } from "@mui/joy";
import React from "react";
import Webcam from "react-webcam";

const videoConstraints = {
  width: 430,
  height: 340,
  facingMode: { exact: "environment" }
};

export const WebcamCapture = ({ setImage }: { setImage: (i: any) => void }) => {
  const webcamRef = React.useRef(null);
  const capture = React.useCallback(
    () => {
      const imageSrc = (webcamRef.current as any).getScreenshot();
      setImage(imageSrc)
    },
    [webcamRef, setImage]
  );
  return (
    <>
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        width={350}
        videoConstraints={videoConstraints}
        screenshotQuality={0.4}
      />
      <Button sx={{ mt: 0 }} color="success"  onClick={capture} size="lg">Capture photo</Button>
    </>
  );
};